export default "__VITE_ASSET__CkvKiBM3__"